import {calculateDistanceBetweenLatLngs} from "@irati/geolocation/src/helpers/geometry"
import {BoundingBox, LatLng} from "@irati/geolocation/src/types"

import {getCardinalBoundsFromBoundingBox} from "./geometry"
import {InfoWindowPosition, InfoWindowProperties} from "../types"

/**
 * Determines the arrow position for the InfoWindow based on the InfoWindow position e.g if its position is at
 * the "top" of the marker then the arrow will be in the opposite direction i.e. "bottom"
 *
 *
 * @returns {InfoWindowPosition} The arrow position
 */
const getArrowPositionFromInfoWindowPosition = (position: InfoWindowPosition): InfoWindowPosition => {
  switch (position) {
    case InfoWindowPosition.TOP:
      return InfoWindowPosition.BOTTOM
    case InfoWindowPosition.RIGHT:
      return InfoWindowPosition.LEFT
    case InfoWindowPosition.LEFT:
      return InfoWindowPosition.RIGHT
    default:
      return InfoWindowPosition.TOP
  }
}

/**
 * Calculates what the best position is for an InfoWindow to be placed based on the bounding box of
 * the map
 *
 * @returns InfoWindowProperties | null Includes the optimal position of the InfoWindow
 *  relative to the marker and also the corresponding arrow position
 */
export const getOptimalInfoWindowProperties = (mapBoundingBox: BoundingBox, markerLatLng: LatLng): InfoWindowProperties | null => {
  if (!Array.isArray(mapBoundingBox) || mapBoundingBox.length !== 4) {
    return null
  }

  const {n, e, s, w} = getCardinalBoundsFromBoundingBox(mapBoundingBox)

  const distances = [
    {
      position: InfoWindowPosition.BOTTOM,
      distance: calculateDistanceBetweenLatLngs(markerLatLng, n)
    },
    {
      position: InfoWindowPosition.LEFT,
      distance: calculateDistanceBetweenLatLngs(markerLatLng, e)
    },
    {
      position: InfoWindowPosition.TOP,
      distance: calculateDistanceBetweenLatLngs(markerLatLng, s)
    },
    {
      position: InfoWindowPosition.RIGHT,
      distance: calculateDistanceBetweenLatLngs(markerLatLng, w)
    }
  ]
  distances.sort((a, b) => (a.distance < b.distance ? -1 : 1))

  const {position} = distances[0]

  return {
    position,
    arrowPosition: getArrowPositionFromInfoWindowPosition(position)
  }
}
